import React from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { InvoiceItemV2 } from '@payer-admin-ui/api/src/invoices/models/ResponseInvoiceV2';
import { AmountFormat } from '../../Format/AmountFormat';

export type LineItemEntryProps = {
  item: InvoiceItemV2;
  index: number;
  editRowCallback: (index: number) => void;
  deleteRowCallback: (index: number) => void;
  disabled: boolean;
};

const LineItemEntry = ({ item, index, editRowCallback, deleteRowCallback, disabled }: LineItemEntryProps) => {
  const { itemType, position, articleNumber, description, quantity, unit, unitPrice, vatPercentage, subtotalPrice } =
    item;

  if (itemType === 'FREEFORM') {
    return (
      <TableRow>
        <TableCell>{position}</TableCell>
        <TableCell>{articleNumber}</TableCell>
        <TableCell>{description}</TableCell>
        <TableCell>
          {quantity} {unit}
        </TableCell>
        <TableCell>{unitPrice && <AmountFormat amount={unitPrice} />}</TableCell>
        <TableCell>{vatPercentage && <AmountFormat amount={vatPercentage} />}</TableCell>
        <TableCell>{subtotalPrice && <AmountFormat amount={subtotalPrice} />}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }} className="py-0" align="right">
          {!disabled && (
            <Icons editRowCallback={() => editRowCallback(index)} deleteRowCallback={() => deleteRowCallback(index)} />
          )}
        </TableCell>
      </TableRow>
    );
  } else {
    return (
      <TableRow>
        <TableCell>{position}</TableCell>
        <TableCell />
        <TableCell colSpan={5}>
          <i>{description}</i>
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }} className="py-0" align="right">
          {!disabled && (
            <Icons editRowCallback={() => editRowCallback(index)} deleteRowCallback={() => deleteRowCallback(index)} />
          )}
        </TableCell>
      </TableRow>
    );
  }
};

export { LineItemEntry };

const Icons = (props: { editRowCallback: () => void; deleteRowCallback: () => void }) => {
  return (
    <>
      <IconButton size="small" onClick={() => props.editRowCallback()}>
        <EditIcon color="info" aria-hidden="true" />
      </IconButton>
      <IconButton size="small" className="ml-2" onClick={() => props.deleteRowCallback()}>
        <DeleteIcon color="error" aria-hidden="true" />
      </IconButton>
    </>
  );
};
